import * as angular from 'angular';
import * as _ from 'lodash';

import { WidgetBase, IWidgetConfiguration } from '../';
import { WideError, Helper } from '../../common/';
import { computeError } from './computeError';

export class GaugeWidgetBase extends WidgetBase {
    baseType = 'gauge';
    col = 0;
    currentValue: number;
    guid: string;
    icon = 'fa-dashboard';
    isGroupMode: boolean;
    isTagMode: boolean;
    options: any;
    row = 0;
    sizeX = 3;
    sizeY = 18;
    tagDefinitionGuid: string;

    constructor(
        private _$q: angular.IQService,
        config?: IWidgetConfiguration
    ) {
        super();
        this.setConfiguration(config);
        if (config) {
            if (config.guid) {
                this.tagDefinitionGuid = config.guid;
            }
        }
        this.guid = Helper.getGuid();
        this.isTagMode = this.tagDefinitionGuid ? true : false;
        this.isGroupMode = !this.isTagMode;
    }

    getErrorLevelAsync(): angular.IPromise<WideError> {
        const value = this.value();
        return this._$q.when(this.computeError(value));
    }

    value(value?: number): number {
        if (value !== null && value !== undefined) {
            this.currentValue = value;
        }
        return this.currentValue;
    }

    getError(): WideError {
        return this.computeError(this.value());
    }

    computeError(value: number): WideError {
        return computeError(value, this.options.bands);
    }

    computeErrorAsync(promise: angular.IPromise<number>): angular.IPromise<WideError> {
        return promise.then(data => {
            return this.computeError(data);
        });
    }

    readData(guid?: string): angular.IPromise<number> {
        throw 'this method must be overridden';
    }
}

